<template>
  <div class="container">
    <div class="alert alert-success fs-3 mt-4 text-center" role="alert" v-if="canSubmit">
      Les candidatures sont ouvertes.
    </div>

    <div v-if="canSubmit">
      <ProgressBar :currentStep="currentStep" :totalSteps="4" />

      <IdentiteCandidat 
        v-if="currentStep === 1" 
        :formData="formData" 
        @update:formData="updateFormData"
        @next="nextStep" 
      />

      <ChoixPoste 
        v-if="currentStep === 2" 
        :formData="formData" 
        @update:formData="updateFormData"
        @next="nextStep"
        @prev="prevStep" 
      />

      <MotivationActivite 
        v-if="currentStep === 3" 
        :formData="formData" 
        @update:formData="updateFormData"
        @next="nextStep"
        @prev="prevStep" 
      />

      <JoindreFichiers 
        v-if="currentStep === 4" 
        :formData="formData" 
        @update:formData="updateFormData"
        @submit="submitForm"
        @prev="prevStep" 
      />

      <!-- Indicateur de progression -->
      <div class="progress mt-4">
        <div class="progress-bar" :style="{ width: progressPercentage + '%' }"></div>
      </div>
    </div>

    <!-- Message si candidature déjà soumise -->
    <div v-else class="container px-sm-5 my-4">
      <div class="alert alert-info text-center" role="alert">
        <span class="fs-3">Vous avez déjà soumis votre dossier de candidature.</span>
      </div>
      <div class="row justify-content-center">
        <div class="col-auto">
          <router-link :to="{ name: 'Status' }" class="btn btn-lg btn-primary">
            Suivre mon dossier
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProgressBar from './ProgressBar.vue'
import IdentiteCandidat from './IdentiteCandidat.vue'
import ChoixPoste from './ChoixPoste.vue'
import MotivationActivite from './MotivationActivite.vue'
import JoindreFichiers from './JoindreFichiers.vue'
import { defineRule } from 'vee-validate'
import "intl-tel-input/build/css/intlTelInput.css";
import intlTelInput from "intl-tel-input";
import parsePhoneNumber from "libphonenumber-js";
import { isValidPhoneNumber } from 'libphonenumber-js'

var iti;
defineRule("telephone", (value) => {
  if (!value || !value.length) return true
  if (!isValidPhoneNumber(iti.getNumber())) {
    return "Le numéro de téléphone n'est pas valide."
  }
  return true
});

export default {
  name: 'FormulaireCandidature',
  inject: [
    "ToastSuccess",
    "ToastError",
    "AlertSuccess",
    "AlertError",
  ],
  components: {
    ProgressBar,
    IdentiteCandidat,
    ChoixPoste,
    MotivationActivite,
    JoindreFichiers
  },
  data() {
    return {
      currentStep: 1,
      userProfile: {},
      canSubmit: true,
      formData: {
        nom: '',
        prenom: '',
        date_naissance: '',
        genre: '',
        email: '',
        phone: '',
        adresse: '',
        poste: '',
        pretention: '',
        presentation: '',
        disponibilite: '',
        images: null
      }
    }
  },
  computed: {
    progressPercentage() {
      return (this.currentStep / 4) * 100;
    }
  },
  async created() {
    await this.getUserProfile();
  },
  mounted() {
    let input = document.querySelector("#phone");
    iti = intlTelInput(input, {
      preferredCountries: ["bj", "bf", "ci", "dj", "ne", "sn", "tg", "ga"],
      initialCountry: "bj",
      utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.19/js/utils.min.js",
    });

    let that = this;
    let appIsAlreadyMounted = false;

    document.querySelector(".iti")?.addEventListener("click", function () {
      if (!appIsAlreadyMounted) {
        appIsAlreadyMounted = !appIsAlreadyMounted;
        const phoneNumber = parsePhoneNumber(iti.getNumber());
        if (phoneNumber) {
          that.formData.phone = phoneNumber.formatNational();
        }
      }
    });
  },
  methods: {
    async getUserProfile() {
      try {
        const response = await this.$http.get("user-profile");
        this.userProfile = response.data;
        this.canSubmit = this.userProfile.step < 1;
      } catch (error) {
        this.ToastError("Erreur lors du chargement du profil");
      }
    },
    updateFormData(newData) {
      this.formData = { ...this.formData, ...newData }
    },
    nextStep() {
      if (this.currentStep < 4) this.currentStep++
    },
    prevStep() {
      if (this.currentStep > 1) this.currentStep--
    },
    async submitForm() {
      try {
        const formData = new FormData()
        
        // Ajout des données textuelles
        Object.keys(this.formData).forEach(key => {
          if (key !== 'images') {
            formData.append(key, this.formData[key]);
          }
        });

        // Ajout des fichiers
        if (this.formData.images) {
          Array.from(this.formData.images).forEach(file => {
            formData.append('images[]', file);
          });
        }

        await this.$http.post('new-candidacies', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        });

        this.AlertSuccess.fire({
          text: "Votre dossier de candidature a été envoyé avec succès !",
        });
        this.$router.push({ name: "Status" });
      } catch (error) {
        if (error.response?.status === 422) {
          this.ToastError.fire({
            title: "Veuillez bien remplir le formulaire et réessayez.",
          });
        }
      }
    }
  }
}
</script>

<style scoped>
legend {
  margin-top: 15px;
  font-weight: bold;
  margin-bottom: 20px;
}

@media (min-width: 768px) {
  .form-control,
  .form-select {
    line-height: 2;
  }
}

.section-title {
  border-bottom: 3px solid #3490dc;
}
</style>